import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Components from '../../../components';
import Client from '../../../services'

const headerMap = {
    "index": {label: "Sl.No.",},
    "_id": {label: "Id",},
    "username": {label: "Username",},
    "name": {label: "Name",},
    "address": {label: "Address",},
    "createdAt": {label: "Created At",}
}

const getValue = (changedValue, dataValue) => {
    if(changedValue === null || changedValue === undefined) return dataValue;
    return changedValue;
}

const StudentInfo = ({data, changes, edit, onChange}) => {


    return <table style={{flex: 1}}>
        <tbody>
            <tr>
                <td>Username:</td>
                <td>{data.username}</td>
            </tr>
            <tr>
                <td>Name:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="name" 
                            onChange={onChange}
                            value={getValue(changes.name, data.name)} 
                        />
                        :
                        data.name
                    }
                </td>
            </tr>
            <tr>
                <td>Address:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="address" 
                            onChange={onChange}
                            value={getValue(changes.address, data.address)} 
                        />
                        :
                        data.address
                    }
                </td>
            </tr>
            <tr>
                <td>Date of Birth:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="dob" 
                            type="date"
                            onChange={onChange}
                            value={getValue(changes.dob, data.dob)} 
                        />
                        :
                        !data.dob ? null : new Date(data.dob).toDateString()
                    }
                
                </td>
            </tr>
            <tr>
                <td>Email:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="email"
                            type="email"
                            onChange={onChange}
                            value={getValue(changes.email, data.email)} 
                        />
                        :
                        data.email
                    }
                </td>
            </tr>
            <tr>
                <td>Contact:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="contact" 
                            onChange={onChange}
                            value={getValue(changes.contact, data.contact)} 
                        />
                        :
                        data.contact
                    }    
                </td>
            </tr>
            <tr>
                <td>Father:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="father" 
                            onChange={onChange}
                            value={getValue(changes.father, data.data.father)} 
                        />
                        :
                        data.data.father
                    }
                </td>
            </tr>
            <tr>
                <td>Mother:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="mother" 
                            onChange={onChange}
                            value={getValue(changes.mother, data.data.mother)} 
                        />
                        :
                        data.data.mother
                    }

                </td>
            </tr>
            <tr>
                <td>School:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="school" 
                            onChange={onChange}
                            value={getValue(changes.school, data.data.school)} 
                        />
                        :
                        data.data.school
                    }
                </td>
            </tr>
        </tbody>
    </table>
}


const StudentProfile = ({...props}) => {
    
    var [student, setStudent] = useState(null)
    var [changes, setChanges] = useState({})
    var [edit, setEdit] = useState(false)
    // Component Did mount
    useEffect(async()=>{
        const {id} = props.match.params
        const url = Client.api.getScopedUrl(`/student/${id}`)
        const {success, data} = await Client.api.get(url)
        if(success){
            setStudent(data)
        }else{
            setStudent({})
        }
    },[])

    const handleSaveChangesEffect = async() => {
        if(Object.keys(changes).length < 1) return;
        const url = Client.api.getScopedUrl(`/student/${props.match.params.id}`)
        try {
            const payload = {
                ...changes,
                _student: props.match.params.id
            }
            const {success, data, message} =await Client.api.put(url, payload)
            if(success){
                setStudent({
                    ...student,
                    ...data.userChanges,
                    data: {
                        ...student.data,
                        ...data.dataChanges
                    }
                })
                setChanges({})
                await Client.alert.fire({
                    icon: "success",
                    title: "Success",
                    body: message,
                    confirmButton: true
                })
            }else{
                Client.alert.fire({
                    icon: "error",
                    title: "Failed",
                    body: message,
                    confirmButton: true
                })
            }
        }catch(error){
            Client.alert.fire({
                icon: "error",
                title: "Failed",
                body: "Something went wrong",
                confirmButton: true
            })
        }
    }
    useEffect(handleSaveChangesEffect, [edit])
    
    if(!student) return null;
    
    const handleChange = (e) => {
        const {name, value} = e.target
        setChanges({
            ...changes,
            [name]: value
        })
    }

    const handleChangeProfilePicResponse = (response) => {
        if(response.success){
            setStudent({
                ...student,
                photo: `${response.data.url}?_random=${Math.random()}`
            })
        }
    }


    const handleToggleEdit = () => setEdit(!edit)


    return <div className="student-profile">
        <nav className="u-flex--center-cross" style={{display: "flex"}}>
            <h2>Student Profile</h2>
            <div style={{flex: 1}}></div>
            <Components.buttons.FlatButton onClick={handleToggleEdit}>{edit? "Save": "Edit"}</Components.buttons.FlatButton>
            <Link to={`/common/exam/marksheet?_student=${student._id}`}>Show Marksheets</Link>
        </nav>
        <div style={{display: 'flex'}}>
            <StudentInfo data={student} changes={changes} edit={edit} onChange={handleChange}/>
            <div style={{width: 200}}>
                <Components.data.Avatar
                    src={student.photo}
                    fieldName="profilePic"
                    uploadUrl={Client.api.getScopedUrl(`/student/${student._id}/profile-pic`)}
                    onUploadSuccess={handleChangeProfilePicResponse}
                />
            </div>
        </div>
    </div>
}

export default StudentProfile